var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound"},[_c('v-container',[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v(" Oops, We couldn't find that page. Go To "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("HOME")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }